export default [
  {
    path: '/unvan',
    name: 'unvan-list',
    component: () => import('@/views/unvan/index.vue'),
    meta: {
      public: false,
      title: 'unvan.Ünvanlar',
      yetki: { k: [2002502] },
    },
  },
]
